'use client'
import React from "react";
import TopBanner from "../WeddingBudgetBanners/topBanner";
import { WeddingBudgetPlan } from "../WeddingBudgetPlan/weddingBudgetPlan";
import WeddingValueProps from "../CardSection/weddingValueProps";
import { BudgetEffectiveTemplate } from "../BudgetEffectiveTemplate/BudgetEffectiveTemplate";
import { BudgetWeddingBenifits } from "../BudgetWeddingBenifits/BudgetWeddingBenifits";
import { BudgetPlanningTools } from "../BudgetPlanningTools/BudgetPlanningTools";
import Footer from "../Footer/footer";
import FAQSection from "../FAQ/faqSection";
import { HeadingWithButton } from "../Common/HeadingWithButton/HeadingWithButton"
import Script from "next/script";
import { KLAVIYO_COMPANY_ID, WEDDING_BUDGET_FORM_ID } from "@/utils/constants/constants";
import { topBannerData } from "@/lib/content/weddingBudgetContent/topBannerContent";
import valuePropsContent from "@/lib/content/weddingBudgetContent/valuePropsContent";
import { carousalImages, paraContent, planData } from "@/lib/content/weddingBudgetContent/weddingBudgetPlanContent";
import { effectiveData, topImageAndheadingEffectiveData } from "@/lib/content/weddingBudgetContent/budgetEffectiveData";
import { BudgetPlanCardsContent, BudgetPlanCardsData } from "@/lib/content/weddingBudgetContent/budgetPlanCardsContent";
import { WeddingBudgetFaqsData } from "@/lib/content/weddingBudgetContent/weddingBudgetFaqsContent";
import { weddingBudgetBenefitsContent } from "@/lib/content/weddingBudgetContent/weddingBudgetBenefitsContent";


export const WeddingBudgetLanding: React.FC<any> = () => {

    return (
        <div>
            <Script
                src={`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KLAVIYO_COMPANY_ID}`}
                strategy="afterInteractive"
                id={'klaviyo1'}
            />
            <TopBanner KlayvioFormId={WEDDING_BUDGET_FORM_ID} banner={topBannerData} bannerImage="https://cdn.buttercms.com/XFMJhqFkTA6IQ9dRtGUV" bannerImageAlt="A free wedding budget template option displayed on a screen." />
            <WeddingBudgetPlan planData={planData}  carousalImages={carousalImages} paraContent={paraContent} />
            <div className="pt-12 bg-white" >
                <WeddingValueProps
                    valueProps={valuePropsContent.valuePropsData}
                />
            </div>
            <BudgetEffectiveTemplate  topContent={topImageAndheadingEffectiveData} effectiveData={effectiveData} />
            <BudgetWeddingBenifits  content={weddingBudgetBenefitsContent} />
            <HeadingWithButton KlayvioFormId={WEDDING_BUDGET_FORM_ID} heading="Stay organized with this free wedding budget template" button="Get Yours Free" />
            <BudgetPlanningTools cardsData={BudgetPlanCardsData} topContent={BudgetPlanCardsContent} />
            <FAQSection faqItems={WeddingBudgetFaqsData} heading={"Frequently Asked Questions"} />
            <HeadingWithButton KlayvioFormId={WEDDING_BUDGET_FORM_ID} heading="Get the best free wedding budget spreadsheet" button="Download Now" />
            <Footer locale="en-ca" />
        </div>
    )
}